import { AxiosResponse } from 'axios'
import { RequestREAD } from 'services/Instances'

export const CostCenterServices = () => {
  const path = 'CentroPlanta'

  const getById = async (id: number): Promise<AxiosResponse<any>> =>
    await RequestREAD.get(`${path}/${id}`)

  const allCostCenter = async (): Promise<AxiosResponse<any>> =>
    await RequestREAD.get(`${path}/`)

  const GetByDescricao = async (
    descricao: string
  ): Promise<AxiosResponse<any>> =>
    await RequestREAD.get(`${path}/GetByDescricao/${descricao}`)

  const AutoCompleteCostCenters = async (
    requestBody: IAutoCompleteCostCentersBody
  ): Promise<AxiosResponse<IGetAutoCompleteCostCentersResponse>> =>
    await RequestREAD.get(`${path}/AutoComplete`, { params: requestBody })

  return {
    AutoCompleteCostCenters,
    GetByDescricao,
    allCostCenter,
    getById
  }
}

export interface IAutoCompleteCostCentersBody {
  nmCentroPlanta: string
  hasDinamicSearch: boolean
}

export interface CentroPlantaEntity {
  idCentroPlanta: number;
  nmCentroPlanta: string;
}

export interface IGetAutoCompleteCostCentersResponse {
  sucesso: boolean;
  mensagem: string;
  detalhe: string;
  tipo: string;
  entity: CentroPlantaEntity[];
}
